module.exports = __webpack_public_path__ + "static/linkedlist-2.4-4f7549dc9b60b462c622536cef980fed.png";